import { SelectDesignTokens } from '@primeuix/themes/types/select';

export const ezSelectThemeConfig: SelectDesignTokens = {
  colorScheme: {
    light: {
      root: {
        focusBorderColor: '#167007',
        borderColor: 'var(--ez-border-color)',
        placeholderColor: 'var(--ez-text-hint-color)',
        hoverBorderColor: 'var(--ez-border-color)',
        disabledBackground: 'rgb(var(--ez-primeng-readonly-bg-color-rgb)/40%)',
        color: 'var(--ez-primary-color)',
      },
      option: {
        selectedBackground: '#F3FFEB',
        focusBackground: '#F3FFEB',
        selectedFocusBackground: '#F3FFEB',
        selectedColor: '#167007',
      },
    },
  },
};
